import { extendTheme } from '@chakra-ui/react'

const theme = extendTheme({
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: false
  },
  fonts: {
    heading: `'Syne', sans-serif`,
    body: `'Outfit', sans-serif`
  },
  styles: {
    global: {
      html: {
        overflowX: 'hidden'
      },
      'html, body, #root': {
        minHeight: '100%',
        height: '100%',
        bg: '#000000',
        color: '#f3f3f5'
      },
      body: {
        overflowX: 'hidden'
      }
    }
  }
})

export default theme
